import { render, staticRenderFns } from "./MainReportTable.vue?vue&type=template&id=8b7ea30a&scoped=true"
import script from "./MainReportTable.vue?vue&type=script&lang=js"
export * from "./MainReportTable.vue?vue&type=script&lang=js"
import style0 from "./MainReportTable.vue?vue&type=style&index=0&id=8b7ea30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7ea30a",
  null
  
)

export default component.exports